/**
 * @file
 * Behaviors for the Tabs Component.
 */

!((Drupal, $) => {
  'use strict';

  /**
   * Setup and attach the Tabs Component behaviors.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.tabs = {
    attach: function(context) {
      const self = this;
      const $tabs = $('.tabs', context);
      const $context = $('.tabs__content__wrapper', context);
      const defaultTab = 0;

      $tabs.each(function(i) {
        const $tab = $(this);
        const $toggle = $tab.find('.tabs__toggle');
        $toggle.on('click', function() {
          self.toggleClickEvent($tab, $context, $(this));
        });

        // set default tab
        if (i === defaultTab) {
          self.toggleClickEvent($tab, $context, $toggle);
        }
      });
    },

    toggleClickEvent: function($tab, $context, $toggle) {
      const $content = $context.find('#' + $toggle.attr('aria-controls'));
      const $contents = $context.find('.tabs__content__open');
      const $tabs = $context.find('.tabs__open');
      const $toggles = $context.find('.tabs__toggle');

      // close open tabs
      $tabs.each(function() {
        const $tabElement = $(this);
        $tabElement.removeClass('tabs__open');
      });
      $contents.each(function() {
        const $contentElement = $(this);
        $contentElement.removeClass('tabs__content__open');
        $contentElement.attr('aria-hidden', 'true');
      });
      $toggles.each(function() {
        const $toggleElement = $(this);
        $toggleElement.attr('aria-expanded', 'false');
        $toggleElement.attr('aria-selected', 'false');
      });

      // open current tab
      $tab.addClass('tabs__open');
      $toggle.attr('aria-expanded', 'true');
      $toggle.attr('aria-selected', 'true');
      $content.attr('aria-hidden', 'false');
      $content.addClass('tabs__content__open');
    }
  };
})(Drupal, jQuery);
